<template>
  <div>
    <div class="row">

      <!-- Current Account Balance -->
      <div class="col-md-6 col-xl-3">
        <div class="card-box gradient-card-1">
          <i class="icon fas fa-dollar-sign"></i>
          <h4 class="mt-0 font-16">Account Balance</h4>
          <h2 class="text-dark my-3 text-center">
            <span>
              {{ accountSnapshot.account_current_balance }}
            </span>
          </h2>
          <p class="mb-0 font-16 text-primary">
            Due on
            <span class="float-right">
              {{ accountSnapshot.due_date }}
            </span>
          </p>
        </div>
      </div>

      <!-- Invoice Generated -->
      <div class="col-md-6 col-xl-3">
        <div class="card-box gradient-card-2">
          <i class="icon fas fa-paperclip"></i>
          <h4 class="mt-0 font-16">Invoice Generated</h4>
          <h2 class="text-dark my-3 text-center">
            <span>
              {{ accountSnapshot.invoice_count }}
            </span>
          </h2>
          <p class="mb-0 font-16 text-primary">
            Current Invoice Billed On
            <span class="float-right">
              {{ accountSnapshot.billing_date }}
            </span>
          </p>
        </div>
      </div>

      <!-- Payment Method -->
      <div class="col-md-6 col-xl-3">
        <div class="card-box gradient-card-3">
          <i class="icon fas fa-cubes"></i>
          <h4 class="mt-0 font-16">Payment Method</h4>
          <h2 class="text-dark my-3 text-center">
            <span>
              {{ accountSnapshot.first_payment_method_desc }}
            </span>
          </h2>
          <p class="mb-0 font-16">
            <a href="https://ndenergyinc.com/forms" target="_blank">Enroll Pre-Authorized (PAP)</a>
          </p>
        </div>
      </div>

      <!-- eBilling -->
      <div class="col-md-6 col-xl-3">
        <div class="card-box gradient-card-4">
          <i class="icon fas fa-leaf"></i>
          <h4 class="mt-0 font-16">Invoice Delivery</h4>
          <h2 class="text-dark my-3 text-center">
            <span>
              {{ accountSnapshot.ebilling_status }}
            </span>
          </h2>
          <p class="mb-0 font-16 text-dark">
            <a v-if="accountSnapshot.ebilling_status === 'Paper'" href="mailto: info@ndenergyinc.com">Enroll e-Billing</a>
            <br v-else />
          </p>
        </div>
      </div>
    </div>

    <div class="row" style="min-height: 360px; max-height: 745px; overflow-y: auto; overflow-x: hidden">
      <div class="col-xl-12">
        <Portlet headertitle="Account Invoice" @refreshContent="getAccountInvoice">
          <div class="card-body pt-0">
            <div class="table-responsive mb-0">
              <table class="table table-hover table-centered mb-0 table-sm">
                <thead class="thead-light">
                  <tr>
                    <th class="text-left">Invoice No.</th>
                    <th class="text-left">Invoice Period</th>
                    <th class="text-center">Billing Date</th>
                    <th class="text-center">Payment Due</th>
                    <th class="text-right">Amount Billed</th>
                    <th class="text-right">Amount Due</th>
                    <th class="text-center">Download</th>
                  </tr>
                </thead>

                <tbody v-if="dataLoading" class="text-center">
                  <tr>
                    <td colspan="7">
                      <b-spinner label="Loading" class="m-2" variant="danger"
                        style="width: 3rem; height: 3rem;"></b-spinner>
                    </td>
                  </tr>
                </tbody>

                <tbody v-else>
                  <tr v-for="invoice in accountInvoice" :key="invoice.invoice_header_id">
                    <td class="text-left">{{ invoice.invoice_num }}</td>
                    <td class="text-left">{{ invoice.invoice_period }}</td>
                    <td class="text-center">{{ invoice.billing_date }}</td>
                    <td class="text-center">{{ invoice.due_date }}</td>
                    <td class="text-right">$ {{ invoice.invoice_total }}</td>
                    <td class="text-right">$ {{ invoice.amount_due_total }}</td>
                    <td class="text-center"><i class="h3 mdi mdi-file-pdf-box text-danger"
                        @click="downloadPDF(invoice)"></i>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </Portlet>
      </div>
    </div>
  </div>
</template>

<script>
import Portlet from '@src/components/portlet'
import { reqAccountInvoice, reqAccountSnapshot, BASE_URL } from '@services'
import axios from 'axios'

export default {
  components: {
    Portlet,
  },

  data() {
    return {
      accountInvoice: [],
      accountSnapshot: [],
      dataLoading: false,
    }
  },

  watch: {
    '$store.state.auth.account_id': function (val) {
      if (val) {
        this.getAccountInvoice()
        this.getAccountSnapshot()
      }
    },
  },

  mounted() {
    this.getAccountInvoice()
    this.getAccountSnapshot()
  },

  methods: {
    async getAccountInvoice() {
      this.dataLoading = true;

      this.accountInvoice = []
      const result = await reqAccountInvoice({
        account: this.$store.state.auth.account_id,
      })
      if (result.status === 'Success') {
        this.accountInvoice = result.data
      } else {
        this.accountInvoice = []
      }
      this.dataLoading = false
    },

    async getAccountSnapshot() {

      this.accountSnapshot = []
      const result = await reqAccountSnapshot({
        account: this.$store.state.auth.account_id,
      })
      // console.log("accountSnapshot = ", this.accountSnapshot)

      if (result.status === 'Success') {
        this.accountSnapshot = result.data[0]
      } else {
        this.accountSnapshot = []
      }
    },

    // Download Invoice PDF
    async downloadPDF(item) {
      try {
        const response = await axios.get(
          `${BASE_URL}/common/download-s3-doc?document_id=${item.document_id}`
        );

        if (response.data.url) {
          const link = document.createElement("a");
          link.href = response.data.url;
          link.setAttribute("download", `${item.invoice_num}.pdf`);
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        } else {
          console.error("No URL returned from server.");
          alert("Failed to get download URL.");
        }
      } catch (error) {
        console.error("Error while downloading PDF:", error);
        alert("An error occurred while downloading the file.");
      }
    },
  },
}
</script>

<style>
.gradient-card-1 {
  position: relative;
  background: linear-gradient(45deg, #ffd3a5 5%, #fd6585 90%);
  color: white;
  overflow: hidden;
}

.gradient-card-1 .icon {
  position: absolute;
  top: 10%;
  right: 0%;
  transform: translate(-30%, -30%) rotate(45deg);
  font-size: 8rem;
  opacity: 0.2;
}

.gradient-card-2 {
  position: relative;
  background: linear-gradient(45deg, #91eae4 5%, #7f7fd5 80%);
  color: white;
  overflow: hidden;
}

.gradient-card-2 .icon {
  position: absolute;
  top: 10%;
  right: -5%;
  transform: translate(-30%, -30%);
  font-size: 8rem;
  opacity: 0.3;
}

.gradient-card-3 {
  position: relative;
  background: linear-gradient(45deg, #FFBBEC 5%, #A9C9FF 60%);
  color: white;
  overflow: hidden;
}

.gradient-card-3 .icon {
  position: absolute;
  top: 10%;
  right: -10%;
  transform: translate(-30%, -30%);
  font-size: 9rem;
  opacity: 0.3;
}


.gradient-card-4 {
  position: relative;
  background: linear-gradient(45deg, #FFFB7D 5%, #85FFBD 60%);
  ;
  color: white;
  overflow: hidden;
}

.gradient-card-4 .icon {
  position: absolute;
  top: 10%;
  right: -10%;
  transform: translate(-30%, -30%);
  font-size: 8rem;
  opacity: 0.3;
}</style>
